<!--@if (!loading) {-->

<!--}-->
<!-- <app-push-notification-manager></app-push-notification-manager>-->
<router-outlet></router-outlet>
<app-error-dialog-manager></app-error-dialog-manager>
@if (loading) {
  <div class="app-loading">
    <div class="app-loading-info">
      <h1>Application is loading...</h1>
      <mat-spinner></mat-spinner>
    </div>
  </div>
}
